// http://kenwheeler.github.io/slick/
var badges = function() {
  const $stageBadge = $(".stage__badge--items[data-slide-animation='true']");

  $stageBadge.not('.slick-initialized').slick({
    autoplay: true,
    arrows: false
  });
};

var stageContainer = document.querySelectorAll(".stage");

var setContainerMarginBottom = function() {
  if (stageContainer.length <= 0) {
    return null;
  }

  setStageMarginBottomForDesktop();
  window.addEventListener("resize", setStageMarginBottomForDesktop);
};

var setStageImageHeight = function() {
  if (stageContainer.length <= 0) {
    return null;
  }

  setStageImageHeightForMobile();
  window.addEventListener("resize", setStageImageHeightForMobile);
};

var setStageMarginBottomForDesktop = function() {
  stageContainer.forEach(function(stage) {
    if (window.screen.width < 1024) {
      return null;
    }

    var dataPositionTop = stage.querySelectorAll('div[data-position="stageTop"]');
    var dataPositionLeftTop = stage.querySelectorAll('div[data-position="stageLeftTop"]');
    var badge = stage.querySelector(".stage__badge--desktop");

    if (badge == null || dataPositionTop.length > 0 || dataPositionLeftTop.length > 0) {
      return null;
    }

    var textHeight = stage.querySelector(".stage__text").offsetHeight;

    if ((badge.offsetHeight + textHeight) > stage.offsetHeight) {
      stage.style.marginBottom = ((badge.offsetHeight + textHeight) - stage.offsetHeight) + 16 + "px";
    }
  });
};

var setStageImageHeightForMobile = function() {
  stageContainer.forEach(function(stage) {
    if (window.screen.width > 768) {
      return null;
    }

    var stageImageOuterHeight = stage.querySelector(".stage__image--outer").offsetHeight;
    var image = stage.querySelector(".stage__image img");
    image.style.height = stageImageOuterHeight+"px";
  });
};

// eslint-disable-next-line
export { badges, setContainerMarginBottom, setStageImageHeight };